import { centeredMainChildGridClasses } from '@/styles/grid';
import clsx from 'clsx';
import * as React from 'react';
import { CountryData, RoamingTab } from '../types';
import Header from './Header';
import TravellingAbroadData from './TravellingAbroadData';
import CallToAbroadData from './CallToAbroadData';
import { AnimatePresence } from 'framer-motion';
import dynamic from 'next/dynamic';
import GlobePlaceholder from '../Globe/GlobePlaceholder';
const Globe = dynamic(() => import('../Globe/Globe'), {
  loading: () => <GlobePlaceholder />,
  ssr: false,
});

type Props = {
  countryData: CountryData;
  activeTab: RoamingTab;
  setActiveTab: React.Dispatch<React.SetStateAction<RoamingTab>>;
};

const CountryRoamingData = ({ countryData, activeTab, setActiveTab }: Props) => {
  if (!countryData) {
    return null;
  }

  return (
    <div className={clsx(centeredMainChildGridClasses, 'flex flex-col gap-y-32')}>
      <Header countryData={countryData} activeTab={activeTab} onChangeTab={setActiveTab} />
      <div className={clsx(centeredMainChildGridClasses)}>
        <div className="col-span-full flex flex-col gap-y-32 md:col-span-6 md:col-start-2">
          <AnimatePresence>
            {activeTab === RoamingTab.TravellingAbroad ? (
              <TravellingAbroadData countryData={countryData} />
            ) : (
              <CallToAbroadData countryData={countryData} />
            )}
          </AnimatePresence>
        </div>
        <div className="relative col-span-full flex justify-center md:col-span-4">
          <Globe showMarker countryCode={countryData.countryCode} />
        </div>
      </div>
    </div>
  );
};

export default CountryRoamingData;
